import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import SourceFlowForm from '@sourceflow-uk/sourceflowform';
import {
    Container,
    Row,
    Col,
    Card
} from 'reactstrap';
import Link from "next/link"
import styles from './styles.module.scss';
import Caret from "/public/site-assets/svg/caret.svg"

export default function LatestPodcasts({
    global,
    pathPrefix,
    customClass = "",
    post,
    content,
    buttonLink,
    buttonTitle,
    buttonLink2,
    buttonTitle2,
    locale,
    formId,
}) {

    return (
        post?.length >= 1 && (
            <section className={`${styles.root} ${customClass}`} >
                <Container>
                    <Row className="align-items-center">
                        <Col lg={6} className="mb-4 mb-lg-0 pe-lg-5">
                            {content ?
                                <SourceFlowText global={global} path={`${pathPrefix}.content`} type="html">
                                    {content}
                                </SourceFlowText>
                                : null}
                            {formId ?
                                <div className="p-4 primary-bg rounded-4 center-form">
                                    <SourceFlowForm
                                        formId={formId}
                                        onSubmitDone={() => (window.location.href = successPageUrl)}
                                    />
                                </div> : 
                                <div>
                                    {buttonLink ?
                                    <div className="mt-4">
                                        <Link href={`${buttonLink}`}>
                                            <a className="primaryBtn no-arrow">
                                                {buttonTitle}
                                            </a>
                                        </Link>
                                        {buttonLink2 ?
                                            <Link href={`${buttonLink2}`}>
                                                <a className="secondaryBtn no-arrow m-0">
                                                    {buttonTitle2}
                                                </a>
                                            </Link> : null}
                                    </div> : null}
                                </div>
                            }
                        </Col>
                        <Col lg={6} className="ps-lg-5">
                            {post?.map((post, index) => (
                                <Card key={index} className="border-0 mb-4 rounded-4">
                                    <Link href={`/${locale ? locale : ""}podcasts/${post.url_slug}/`}>
                                        <a>
                                            <Row className="m-0">
                                                <Col sm={4} xl={3} className="p-2">
                                                    <SourceFlowImage
                                                        src={post?.image ? post.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                                        size="800x800"
                                                        alt={post?.title}
                                                        className="card-img rounded-4"
                                                    />
                                                </Col>
                                                <Col sm={8} xl={9} className="py-4">
                                                    <div className="d-flex flex-wrap justify-content-between h-100">
                                                        <p className="post-title fs-5 w-100"><strong>{post?.title}</strong></p>
                                                        <div className="d-flex align-items-center">
                                                            <span className="play-icon me-3">
                                                                <Caret />
                                                            </span>
                                                            {post?.button_title}
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </a></Link>
                                </Card>
                            ))}
                        </Col>
                    </Row>
                </Container>
            </section>
        )
    )
}